<template>
  <div class="c-requestAddTitle">
    <div
      class="c-requestAddTitle_text"
      v-if="!isFromCoconalaApp"
    >
      <h1>公開依頼を投稿</h1>
    </div>
    <div class="c-requestAddTitle_banner">
      <a
        href="/pages/about_request"
        target="_blank"
      >
        <img
          src="@/assets/images/common/banner/request_guide_pc.png"
          alt="公開依頼のはじめかたガイド"
          width="306"
          height="42"
          v-if="isPC"
        />
        <img
          src="@/assets/images/common/banner/request_guide_sp.png"
          alt="公開依頼はじめかたガイド"
          width="270"
          height="91"
          v-else-if="isSP || isTB"
        />
      </a>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'RequestAddTitle',
  computed: {
    ...mapGetters('ui', ['isPC', 'isTB', 'isSP']),
    ...mapGetters('auth', ['isFromCoconalaApp'])
  }
}
</script>
<style lang="scss" scoped>
.c-requestAddTitle {
  a {
    @include link-effect;
  }

  h1 {
    font-weight: bold;
  }
}

@media (max-width: breakpoint(Requests, M)) {
  .c-requestAddTitle {
    display: flex;
    flex-direction: column;

    align-items: center;
    justify-content: center;

    &_text {
      display: flex;
      height: 48px;
      font-size: 15px;

      align-items: center;
      justify-content: center;
    }

    &_banner {
      padding-top: 12px;
      width: 100%;
      border-top: 1px solid $color-gray-200;
      background-color: $color-gray-50;
      text-align: center;
    }
  }
}

@media (min-width: breakpoint(Requests, M) + 1) {
  .c-requestAddTitle {
    display: flex;
    margin-top: 36px;

    align-items: center;
    justify-content: space-between;

    &_text {
      font-size: 32px;
    }
  }
}
</style>
